import { SUPPORTED_IMAGE_MIME_TYPES } from '@shared';

/** Match server default MAX_UPLOAD_SIZE_MB (15). */
export const LOCAL_IMAGE_MAX_BYTES = 15 * 1024 * 1024;

const SUPPORTED = new Set<string>(SUPPORTED_IMAGE_MIME_TYPES);

export function validateLocalImageBlob(blob: Blob): void {
  if (!(blob instanceof Blob) || blob.size <= 0) {
    throw new Error('Invalid image: empty or missing file.');
  }
  if (blob.size > LOCAL_IMAGE_MAX_BYTES) {
    throw new Error(
      `Image is too large (max ${LOCAL_IMAGE_MAX_BYTES / (1024 * 1024)} MB).`,
    );
  }
  const mime = (blob.type || '').toLowerCase();
  if (!SUPPORTED.has(mime)) {
    throw new Error(
      'Unsupported image type. Use JPEG, PNG, or WebP.',
    );
  }
}
